// extracted by mini-css-extract-plugin
export default {"loaderText":"Loader_loaderText__L4zBJ"};